import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';

export default function AboutPage() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600 }}>
        Cash Offer
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography component="h2" variant="h4" gutterBottom align="center">
              Recieve a Rocket Offer Cash Offer
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Sell your home with ease and simplicity. Rocket Offer will provide you with a competitive cash offer for your property in just a few steps. To get started, simply enter your address and confirm that you are either the homeowner or the representing real estate agent by checking a box. It's that straightforward—no complicated processes or endless paperwork. Your hassle-free home-selling experience starts here.
            </Typography>
            <Box component="form" sx={{ mt: 3 }}>
              <TextField
                id="addressInput"
                label="Enter Your Address"
                variant="outlined"
                fullWidth
                required
              />
              <FormControlLabel
                control={<Checkbox id="ownershipCheck" required />}
                label="I am the homeowner or representing real estate agent."
                sx={{ mt: 2 }}
              />
              <Button
                type="submit"
                variant="outlined"
                sx={{ mt: 3 }}
              >
                Get Cash Offer
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
